import React from "react";
import { Zap, ArrowRight, Loader2 } from "lucide-react";
import { SX, TX } from "./studioTokens";

const formatDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
};

const ApiIndicator = ({ balance, loading, onManage }) => {
  const total = Number(balance?.allocation_credits || balance?.monthly_credits || 0);
  const remaining = Number(balance?.balance ?? balance?.credits ?? 0);
  const used = balance?.used_this_period != null
    ? Number(balance.used_this_period)
    : Math.max(total - remaining, 0);
  const percentage = total > 0 ? Math.min(Math.round((used / total) * 100), 100) : 0;
  const planName = balance?.plan_name || "Current plan";
  const resetDate = formatDate(balance?.period_end);
  const hasData = Boolean(balance && total > 0);

  return (
    <div className={`${SX.card} p-5`}>
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className={TX.overline}>API Usage</div>
        <div className="min-w-0">
          <span className="inline-flex max-w-full items-center gap-1 px-2.5 py-0.5 rounded-full bg-[#FBF5FA] text-[#893F82] text-[11.5px] font-semibold">
            <Zap size={12} className="flex-shrink-0" />
            <span className="truncate">{loading ? "Loading" : planName}</span>
          </span>
        </div>
      </div>

      <div className="flex items-baseline justify-between gap-3 mb-1">
        <span className="min-w-0 text-[28px] font-semibold text-[#1A1A1A] tracking-[-0.02em] truncate">
          {loading ? (
            <span className="inline-flex items-center gap-2 text-[16px] text-[#52525B]">
              <Loader2 size={15} className="animate-spin" />
              Loading
            </span>
          ) : hasData ? (
            remaining.toLocaleString()
          ) : (
            "--"
          )}
        </span>
        <span className="text-[12.5px] font-semibold text-[#893F82] whitespace-nowrap">
          {hasData ? `${percentage}% used` : "No usage"}
        </span>
      </div>
      <div className="text-[12px] text-[#52525B] mb-3">credits remaining</div>

      <div className="flex items-end gap-2 mb-3">
        <div className="flex-1 h-2 rounded-full bg-[#F5F5F5] overflow-hidden">
          <div className="h-full bg-[#A04A97] transition-all duration-300" style={{ width: `${hasData ? percentage : 0}%` }} />
        </div>
      </div>

      <div className="text-[12px] text-[#8A8A90] mb-4 leading-[1.45]">
        {hasData ? `${used.toLocaleString()} / ${total.toLocaleString()}` : "Usage balance unavailable"}
        {resetDate ? ` · Resets ${resetDate}` : ""}
      </div>

      <button
        type="button"
        onClick={onManage}
        className="text-[13px] font-semibold text-[#A04A97] hover:text-[#893F82] flex items-center gap-1.5"
      >
        Manage usage <ArrowRight size={14} />
      </button>
    </div>
  );
};

export default ApiIndicator;
